import { useAnalyticsParams } from '../../../modules/AnalyticsParams/hooks/useAnalyticsParams';
import { createAnalyticsTableData } from './utils/createAnalyticsTableData';
export const useAnalyticsReportTable = ({ reportData, columns, sorting, onSortingChange, isLoading, activeSeries, }) => {
    const params = useAnalyticsParams();
    const getIsFirstRowSummary = () => {
        if (!reportData) {
            return false;
        }
        return 'summary' in reportData.report && !!reportData.report.summary;
    };
    return {
        isLoading,
        columns,
        data: createAnalyticsTableData(reportData, columns, sorting),
        activeColumnId: activeSeries,
        sorting,
        onSortingChange,
        emptyMessage: 'No data found in this date range',
        isFirstRowSummary: getIsFirstRowSummary(),
        precision: params.groupBy.value.value,
    };
};
